module.exports = __webpack_public_path__ + "static/img/2.cc0a02e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R142B/2.jpg
// module id = SzMz
// module chunks = 1